import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import WarningModal from 'shared/lib/components/modals/warningModal';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'shared/lib/components/modals/modal';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { filesApi } from 'entities/file/api/filesApi';

export type DeleteFileModalControllerActions = {
  afterFileDelete?: (id: string) => void;
};

export default observer(function DeleteFileModalController({
  id,
  afterFileDelete,
  handleClose,
}: {
  id: string;
} & DeleteFileModalControllerActions & {
    handleClose: ModalProps['handleClose'];
  }) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  return (
    <>
      <WarningModal
        mainText={t('warnings.delete.fileMain')}
        secondText={t('warnings.delete.fileSecond')}
        isOpen={true}
        onCancel={handleClose}
        onContinue={async () => {
          try {
            await filesApi.delete(id);
            afterFileDelete && afterFileDelete(id);
          } catch (e) {
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
            console.error(e);
          }
          handleClose();
        }}
      ></WarningModal>
    </>
  );
});
